import S from './hero.module.scss';
import { useEffect, useState } from 'react'


export default function Hero() {


    return (
        <header data-aos='fade-down'>
            <div className={S.backgroundImage} ></div>
            <div className={S.backgroundColor} ></div>
            <div className={S.container}>
                <span className={S.top} data-aos='fade-right'>Today is</span>
                <span className={S.main}>Day:
                    <span className={S.number}>
                        {
                            Math.floor((Date.now() - new Date("2022-3-13").getTime()) * 1 / (1000 * 60 * 60 * 24)) - 10
                        }
                    </span>
                </span>
                <NextDay />
            </div>
            <div className={S.bar}></div>
        </header>
    )
}
{/* Math.floor((Date.now() - new Date(2022, 3, 12).getTime()) * 1 / (1000 * 60 * 60 * 24)) */ }


function NextDay() {
    const [time, setTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, [time]);

    return (
        <span data-aos='fade-left' className={S.bottom}>Next in {23 - new Date().getHours()}h {59 - new Date().getMinutes()}m <span className={S.em}>{60 - new Date().getSeconds()}</span>s</span>
    )
}
